import * as React from 'react';
import { useDispatch } from 'react-redux';

import { FormEvent, useEffect, useState } from 'react';
import { greys, mainColors } from '../../../styling/theme';
import { logOut } from '../../../redux/auth/actions';
import RaptorWithRs from '../../../images/RaptorWithRs';
import { zIndexes } from '../../../styling/zIndexes';
import { useLocation } from 'react-router-dom';
import jwt_decode from 'jwt-decode';
import { validatePassword } from '../../../utilities/accountDetailsValidation';
import clsx from 'clsx';
import { ClassNameMap, Tooltip } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Help, Visibility, VisibilityOff } from '@mui/icons-material';
import axios from 'axios';
import { FAST_API_URL } from '../../../utilities/apiConstants';

const useStyles = makeStyles(() => ({
  mainContainer: {
    padding: '8vh 8vw',
    minWidth: 920,
    position: 'relative',
    height: '100%',
    zIndex: zIndexes.content,
  },
  raptorWithRs: {
    width: 200,
    marginBottom: '0.75rem',
  },
  pageTitle: {
    fontSize: '1.50rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
    color: mainColors.mainBlue,
  },
  toLogin: {
    display: 'flex',
    gap: '0.31rem',
    alignItems: 'center',
    padding: '0 0 0.5rem 0',
    color: greys.grey600,
    fontWeight: 500,
    fontSize: 12,
    '& a': {
      color: mainColors.mainBlue,
      textDecoration: 'none',
      fontWeight: 300,
    },
  },
  errorTitle: {
    fontSize: '1.00rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
    color: mainColors.Fail,
    width: '20.00rem',
  },
  description: {
    fontSize: '0.88rem',
    fontWeight: 400,
    marginBottom: '0.5rem',
    color: greys.grey600,
    width: '20.00rem',
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginTop: '0.5rem',
  },
  input: {
    padding: '0.62rem 0.31rem',
    borderRadius: '0.25rem',
    border: `1px solid ${greys.grey100}`,
    fontSize: '0.94rem',
    fontWeight: 400,
    color: greys.grey800,
    '&::placeholder': {
      color: greys.grey400,
    },
    width: '20.00rem',
  },
  input_password: {
    padding: '0.62rem 2.50rem 0.62rem 0.31rem',
    borderRadius: '0.25rem',
    border: `1px solid ${greys.grey100}`,
    fontSize: '0.94rem',
    fontWeight: 400,
    color: greys.grey800,
    '&::placeholder': {
      color: greys.grey400,
    },
    width: '20.00rem',
  },
  inputGroup: {
    padding: '0.5rem 0',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
  },
  email: {
    fontSize: '1.00rem',
    fontWeight: 600,
    color: mainColors.mainBlue_lighter,
    padding: '0.31rem 0',
  },
  validationMessage: {
    fontSize: '0.75rem',
    fontWeight: 400,
    color: mainColors.Fail,
  },
  resendLink: {
    display: 'flex',
    gap: '0.31rem',
    alignItems: 'center',
    padding: '0 0 0.25rem 0',
    color: greys.grey600,
    fontWeight: 300,
    '& a': {
      color: mainColors.mainBlue,
      textDecoration: 'none',
    },
  },
  submitButton: {
    all: 'unset',
    marginTop: '0.5rem',
    width: '20.00rem',
    padding: '0.62rem 0',
    borderRadius: '0.25rem',
    fontSize: '0.94rem',
    fontWeight: 400,
    color: 'white',
    cursor: 'pointer',
    backgroundColor: mainColors.mainBlue,
    textAlign: 'center',
  },
  submitButton_inactive: {
    marginTop: '0.5rem',
    width: '20.00rem',
    padding: '0.62rem 0',
    borderRadius: '0.25rem',
    fontSize: '0.94rem',
    fontWeight: 400,
    color: 'white',
    backgroundColor: greys.grey300,
    textAlign: 'center',
  },
  newPasswordGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5rem',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  input_valid: {
    border: `1px solid ${mainColors.Pass}`,
    backgroundColor: mainColors.Pass_veryLight,
  },
  input_not_valid: {
    border: `1px solid ${mainColors.Fail}`,
    backgroundColor: mainColors.Fail_veryLight,
  },
  inputValidationMessageContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    gap: '0.31rem',
    '& svg': {
      fontSize: '1.00rem',
      color: greys.grey600,
    },
  },
  inputValidationMessage: {
    fontSize: '0.75rem',
    fontWeight: 400,
    color: mainColors.mainBlue,
  },
  inputValidationMessage_valid: {
    color: mainColors.Pass,
  },
  inputValidationMessage_not_valid: {
    color: mainColors.Fail,
  },
  tooltipContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.31rem',
  },
  tooltipTitle: {
    fontSize: '0.88rem',
    fontWeight: 600,
  },
  tooltipItem: {
    fontSize: '0.62rem',
  },
  passwordInput: {
    width: 'fit-content',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  },
  showPasswordButton: {
    position: 'absolute',
    right: '0.62rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '& svg': {
      fontSize: '1.56rem',
      color: greys.grey600,
    },
  },
  feedbackContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    marginTop: '0.5rem',
  },
  authMessage: {
    fontSize: '0.88rem',
    fontWeight: 600,
    color: greys.grey600,
    width: '20.00rem',
  },
}));

const passwordValidationStyles = (password: string, classes: ClassNameMap) => {
  if (password.length === 0) {
    return classes.input_password;
  } else if (password.length > 0 && validatePassword(password)) {
    return clsx(classes.input_password, classes.input_valid);
  } else {
    return clsx(classes.input_password, classes.input_not_valid);
  }
};

const confirmPasswordValidation = (
  password: string,
  confirmPassword: string,
  classes: ClassNameMap,
) => {
  if (confirmPassword.length === 0) {
    return classes.input;
  } else if (
    confirmPassword.length > 0 &&
    validatePassword(confirmPassword) &&
    password === confirmPassword
  ) {
    return clsx(classes.input, classes.input_valid);
  } else {
    return clsx(classes.input, classes.input_not_valid);
  }
};

const getAuthMessageColor = (authStatus: 'loading' | 'success' | 'error') => {
  switch (authStatus) {
    case 'loading':
      return greys.grey600;
    case 'success':
      return mainColors.Pass;
    case 'error':
      return mainColors.Fail;
  }
};

const ResetPassword = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();

  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);

  const [authMessage, setAuthMessage] = useState<string>('');
  const [authStatus, setAuthStatus] = useState<'loading' | 'error' | 'success'>(
    'loading',
  );
  const [validationMessage, setValidationMessage] = useState<string>('');
  const [tokenExpired, setTokenExpired] = useState<boolean>(false);

  const [tokenValid, setTokenValid] = useState<
    'no_token' | 'invalid' | 'valid'
  >('no_token');
  const [tokenEmail, setTokenEmail] = useState<string>('');
  const resetToken = location.search.split('token=')[1];

  // this function takes the user input for username and auto formats it with our desired format
  // currently this just means making all characters lowercase
  const handleEmailInputEnforcement = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setEmail(event.target.value.toLowerCase());
  };

  useEffect(() => {
    dispatch(logOut());
    if (resetToken) {
      try {
        const decryptedToken: any = jwt_decode(resetToken);
        setTokenEmail(decryptedToken.user_email);
        setTokenValid('valid');
      } catch (error) {
        setTokenValid('invalid');
      }
    } else {
      setTokenValid('no_token');
    }
  }, []);

  const handleSendRequest = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    setAuthStatus('loading');
    setAuthMessage('Submitting reset request...');
    axios
      .post(
        `${FAST_API_URL}/v1/external_user_management/update_user_passwd_invitation`,
        {
          user_email: email,
        },
      )
      .then((res) => {
        if (res.status === 200) {
          setAuthStatus('success');
          setAuthMessage('Password reset link sent.');
        } else {
          setAuthStatus('error');
          setAuthMessage(res.data.detail);
        }
      })
      .catch((err) => {
        setAuthStatus('error');
        setAuthMessage(
          err.response?.data?.detail ||
            'An error occurred while sending the password reset link',
        );
      });
  };

  const handleNewPassword = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setValidationMessage('Passwords do not match');
      return;
    } else if (
      !validatePassword(password) ||
      !validatePassword(confirmPassword)
    ) {
      setValidationMessage('Password not valid');
      return;
    } else {
      setAuthStatus('loading');
      setValidationMessage('');
      setAuthMessage('Submitting new password...');
      axios
        .put(
          `${FAST_API_URL}/v1/external_user_management/update_forget_passwd`,
          {
            user_password: password,
          },
          {
            headers: {
              Authorization: 'Bearer ' + resetToken,
            },
          },
        )
        .then((res) => {
          if (res.status === 200) {
            setAuthStatus('success');
            setAuthMessage('Password updated successfully.');
            setTimeout(() => {
              window.location.href = '/raptor/login';
            }, 500);
          } else {
            setAuthStatus('error');
            setAuthMessage('Unknown Error. Please contact RiskSystem support.');
          }
        })
        .catch((err) => {
          setAuthStatus('error');
          setAuthMessage(
            err.response?.data?.detail ||
              'An error occurred while updating the password',
          );
        });
    }
  };

  return (
    <div className={classes.mainContainer}>
      <RaptorWithRs className={classes.raptorWithRs} />
      <div>
        <div className={classes.pageTitle}>Reset Password</div>
        <div className={classes.toLogin}>
          <div>Go to:</div>
          <a href="/raptor/login">Login Page.</a>
        </div>
        {tokenValid === 'valid' ? (
          <>
            <div className={classes.email}>{tokenEmail}</div>
            <div className={classes.description}>
              Please choose a new password.
            </div>
            <form
              onSubmit={handleNewPassword}
              autoComplete="off"
              className={classes.inputsContainer}
            >
              <div className={classes.inputGroup}>
                <div className={classes.newPasswordGroup}>
                  <div className={classes.passwordInput}>
                    <input
                      id="password-input"
                      type={showPassword ? 'text' : 'password'}
                      placeholder="New Password"
                      autoComplete="new-password"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      className={passwordValidationStyles(password, classes)}
                    />
                    <div
                      className={classes.showPasswordButton}
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </div>
                  </div>
                  <div className={classes.inputValidationMessageContainer}>
                    <Tooltip
                      title={
                        <div className={classes.tooltipContainer}>
                          <div className={classes.tooltipTitle}>
                            For security, we enforce the following password
                            rules:
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must be at least 12 characters long.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 uppercase letter.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 lowercase letter.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 number.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 special character.
                          </div>
                        </div>
                      }
                      placement="right-end"
                    >
                      <Help />
                    </Tooltip>
                    {password.length > 0 ? (
                      validatePassword(password) ? (
                        <div
                          className={clsx(
                            classes.inputValidationMessage,
                            classes.inputValidationMessage_valid,
                          )}
                        >
                          Password valid.
                        </div>
                      ) : (
                        <div
                          className={clsx(
                            classes.inputValidationMessage,
                            classes.inputValidationMessage_not_valid,
                          )}
                        >
                          Password not valid.
                        </div>
                      )
                    ) : null}
                  </div>
                </div>
                <div className={classes.newPasswordGroup}>
                  <div className={classes.passwordInput}>
                    <input
                      id="confirm-password-input"
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder="Confirm Password"
                      autoComplete="new-password"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      className={confirmPasswordValidation(
                        password,
                        confirmPassword,
                        classes,
                      )}
                    />
                    <div
                      className={classes.showPasswordButton}
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </div>
                  </div>
                  <div className={classes.inputValidationMessageContainer}>
                    <Tooltip
                      title={
                        <div className={classes.tooltipContainer}>
                          <div className={classes.tooltipTitle}>
                            For security, we enforce the following password
                            rules:
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must be at least 12 characters long.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 uppercase letter.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 lowercase letter.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 number.
                          </div>
                          <div className={classes.tooltipItem}>
                            {' '}
                            - Must contain at least 1 special character.
                          </div>
                        </div>
                      }
                      placement="right-end"
                    >
                      <Help />
                    </Tooltip>
                    {confirmPassword.length > 0 ? (
                      validatePassword(confirmPassword) ? (
                        password === confirmPassword ? (
                          <div
                            className={clsx(
                              classes.inputValidationMessage,
                              classes.inputValidationMessage_valid,
                            )}
                          >
                            Passwords match.
                          </div>
                        ) : (
                          <div
                            className={clsx(
                              classes.inputValidationMessage,
                              classes.inputValidationMessage_not_valid,
                            )}
                          >
                            Passwords do not match.
                          </div>
                        )
                      ) : (
                        <div
                          className={clsx(
                            classes.inputValidationMessage,
                            classes.inputValidationMessage_not_valid,
                          )}
                        >
                          Password not valid.
                        </div>
                      )
                    ) : null}
                  </div>
                </div>
              </div>
              <div className={classes.validationMessage}>
                {validationMessage}
              </div>
              {validatePassword(password) &&
              validatePassword(confirmPassword) &&
              password === confirmPassword ? (
                <button type="submit" className={classes.submitButton}>
                  Reset
                </button>
              ) : (
                <div className={classes.submitButton_inactive}>Reset</div>
              )}
              <div className={classes.feedbackContainer}>
                {authMessage && (
                  <div
                    className={classes.authMessage}
                    style={{
                      color: getAuthMessageColor(authStatus),
                    }}
                  >
                    {authMessage}
                  </div>
                )}
              </div>
              {tokenExpired ? (
                <div className={classes.resendLink}>
                  <a href="/raptor/reset-password">
                    Click here to request another reset email.
                  </a>
                </div>
              ) : null}
            </form>
          </>
        ) : null}
        {tokenValid === 'no_token' ? (
          <>
            <div className={classes.description}>
              Enter email address to receive a password reset link.
            </div>
            <>
              <form
                onSubmit={handleSendRequest}
                autoComplete="off"
                className={classes.inputsContainer}
              >
                <div className={classes.inputGroup}>
                  <input
                    id="email-input"
                    type="email"
                    placeholder="Email"
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    value={email}
                    onChange={(e) => handleEmailInputEnforcement(e)}
                    className={classes.input}
                  />
                </div>
                {email.length > 0 ? (
                  <button type="submit" className={classes.submitButton}>
                    Send Request
                  </button>
                ) : (
                  <div className={classes.submitButton_inactive}>
                    Send Request
                  </div>
                )}
                <div className={classes.feedbackContainer}>
                  {authMessage && (
                    <div
                      className={classes.authMessage}
                      style={{
                        color: getAuthMessageColor(authStatus),
                      }}
                    >
                      {authMessage}
                    </div>
                  )}
                </div>
              </form>
            </>
          </>
        ) : null}
        {tokenValid === 'invalid' ? (
          <>
            <div className={classes.errorTitle}>
              Password reset token is invalid.
            </div>
            <div className={classes.description}>
              Please re-try email address to receive a password reset link. If
              the issue persists, please contact RiskSystem support.
            </div>
            <form
              onSubmit={handleSendRequest}
              autoComplete="off"
              className={classes.inputsContainer}
            >
              <div className={classes.inputGroup}>
                <input
                  id="email-input"
                  type="email"
                  placeholder="Email"
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                  value={email}
                  onChange={(e) => handleEmailInputEnforcement(e)}
                  className={classes.input}
                />
              </div>
              {email.length > 0 ? (
                <button type="submit" className={classes.submitButton}>
                  Send Request
                </button>
              ) : (
                <div className={classes.submitButton_inactive}>
                  Send Request
                </div>
              )}
              <div className={classes.feedbackContainer}>
                {authMessage && (
                  <div
                    className={classes.authMessage}
                    style={{
                      color: getAuthMessageColor(authStatus),
                    }}
                  >
                    {authMessage}
                  </div>
                )}
              </div>
            </form>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ResetPassword;
